import { EQueueType } from "src/Types/ReDoc/EQueue";
import { useAppSelector } from ".";
import { RootState } from "src/store";


const useEQSelector = <T = unknown>( type: EQueueType, filedName: string ): T => {
    const part =
        type === EQueueType.Damask
            ? "eQueueDamask"
            : type === EQueueType.Return
                ? "eQueueReturn"
                : "eQueueEnter";
    const selectorFunc = ( state: RootState ): T => {
        const source = state as unknown as Record<string, Record<string, unknown>>;
        return source[part]?.[filedName] as T;
    };
    return useAppSelector( selectorFunc );
};

export default useEQSelector;
